import AuthenticationService from '@/services/authentication';
import statusCodes from '@/constants/statusCodes';
import store from '@/store';

let isRefreshing = false;

export default async function callRefreshIfNeeded(error) {
  if (error.status === statusCodes.UNAUTHORIZED && !isRefreshing) {
    isRefreshing = true;

    return AuthenticationService.refreshSession()
      .catch((exceptionError) => {
        const statusCode = (exceptionError?.response?.status
          ?? statusCodes.INTERNAL_SERVER_ERROR);

        if (statusCode === statusCodes.FORBIDDEN) {
          store.dispatch('setRefreshTokenExpired', true);

          AuthenticationService.redirectToLogin(true);
          return;
        }

        if (statusCode === statusCodes.UNAUTHORIZED) {
          return;
        }

        return AuthenticationService.logout(true); // eslint-disable-line consistent-return
      })
      .finally(() => {
        isRefreshing = false;
      });
  }

  return Promise.resolve();
}
